import { SendHorizontal } from "lucide-react";
import { WeaveIcon } from "@/components/atoms/WeaveIcon";
import { useLocation, useNavigate } from "react-router-dom";

// Route the launcher to the multi-agent chat (NOT dev-agent). Hidden on the
// multi-agent surface itself, which has its own composer.
const HIDDEN_PATHS = ["/weave"];

export function FloatingChatButton() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleOpenChat = () => {
    navigate("/weave");
  };

  const shouldHide = HIDDEN_PATHS.some(path => location.pathname.startsWith(path));

  if (shouldHide) {
    return null;
  }

  return (
    <button
      type="button"
      onClick={handleOpenChat}
      className="floating-chat-launcher"
      aria-label="Let's Weave"
      title="Let's Weave"
    >
      <span className="floating-chat-launcher__mark">
        <WeaveIcon className="h-4 w-4" />
      </span>
      <span className="floating-chat-launcher__copy">
        <span>Let's Weave</span>
      </span>
      <span className="floating-chat-launcher__send">
        <SendHorizontal className="h-3.5 w-3.5" />
      </span>
    </button>
  );
}
